import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { CModal, CModalBody, CButton } from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';
import { cilX, cilDelete } from '@coreui/icons';

import { setShowRemovePopup } from '../../../actions/general';

const DoubleConfirmRemovePopup = ({ id, onAccept, onClose, loading, textRemove = 'delete' }) => {
     const dispatch = useDispatch();
     const handleCancelButtonClick = () => {
          if (onClose) {
               onClose();
          } else {
               dispatch(setShowRemovePopup(false));
          }
     };
     const handleDeleteButtonClick = () => {
          onAccept(id);
     };

     return (
          <>
               <CModal visible={true} alignment="center" className="remove-popup">
                    <CModalBody className="text-center">
                         <CIcon icon={cilX} className="icon-close-popup" onClick={handleCancelButtonClick} />
                         <div className="remove-popup-icon">
                              <CIcon icon={cilDelete} className="text-danger" height={38} alt="CoreUI Icons Delete" />
                         </div>
                         <h2>Are you sure?</h2>
                         <div className="remove-popup-description">
                              <p className="fw-bold">Are you really sure you want to {textRemove} this element? It will go away forever!</p>
                         </div>
                         <div className="btn-delete mb-1 position-relative">
                              <CButton
                                   color="danger"
                                   className="r-3 text-uppercase d-inline-block btn-yes"
                                   onClick={handleDeleteButtonClick}
                                   disabled={loading}
                              >
                                   {loading ? (
                                        <>
                                             Waiting
                                             <span className="dots-waiting"></span>
                                        </>
                                   ) : (
                                        <>PROCEED TO {textRemove}</>
                                   )}
                              </CButton>
                         </div>
                         <div className="mb-3">
                              <CButton className="d-inline-block btn-cancel" onClick={handleCancelButtonClick} color="link">
                                   Cancel
                              </CButton>
                         </div>
                    </CModalBody>
               </CModal>
          </>
     );
};

DoubleConfirmRemovePopup.propTypes = {
     id: PropTypes.string,
     onAccept: PropTypes.func,
     loading: PropTypes.bool,
};

export default DoubleConfirmRemovePopup;
